import { Component } from '@angular/core';

@Component({
  selector: 'app-settings',
  template: `<div class="settings">
    <router-outlet></router-outlet>
  </div>`,
})
export class SettingsComponent {}
